import { DeviceGrades } from './deviceDetection.js'

const gradeAndroidBasedOnGPU = function(gpu) {
    //Adreno
    //Mali
    // Handle powerVR and Tegra?  Both would prob be A

    try {
        switch (gpu.substring(0, 3)) {
            case 'Adr':
                gradeAdreno(gpu)
            case 'Mal':
                gradeMali(gpu)
            default:
                return DeviceGrades.A
        }
    } catch {
        return DeviceGrades.A
    }
}

const gradeAdreno = function(gpu) {
    try {
        let gpuInforray = gpu.split(' ')
        let versionNumber = parseInt(gpuInforray[gpuInforray.length - 1])

        if (versionNumber > 405) {
            return DeviceGrades.A
        } else if (versionNumber <= 405 && versionNumber > 304) {
            return DeviceGrades.C
        } else {
            return DeviceGrades.F
        }
    } catch {
        return DeviceGrades.A
    }
}

const gradeMali = function(gpu) {
    try {
        let gpuInforray = gpu.split('-')
        let versionNumber = gpuInforray[gpuInforray.length - 1]
        switch (versionNumber) {
            case 'G76':
                return DeviceGrades.A
            case 'G72':
                return DeviceGrades.A
            case 'G71':
                return DeviceGrades.A
            case 'G52':
                return DeviceGrades.A
            case 'G51':
                return DeviceGrades.A
            case 'G31':
                return DeviceGrades.A
            case 'T880':
                return DeviceGrades.A
            case 'T860':
                return DeviceGrades.A
            case 'T830':
                return DeviceGrades.A
            case 'T820':
                return DeviceGrades.A
            case 'T760':
                return DeviceGrades.A
            case 'T720':
                return DeviceGrades.A
            case '470':
                return DeviceGrades.A
            case '450':
                return DeviceGrades.A
            case '430':
                return DeviceGrades.A
            default:
                return DeviceGrades.A
        }
    } catch {
        return DeviceGrades.A
    }
}

export const gradeAndroid = function() {
    // Create a canvas element which can be used to retrieve information about the GPU.
    try {
        var canvas = document.createElement('canvas')
        if (canvas) {
            var context = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
            if (context) {
                var info = context.getExtension('WEBGL_debug_renderer_info')
                if (info) {
                    var renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL)
                    // Unused.  May be useful at some point.
                    // var vendor = context.getParameter(info.UNMASKED_VENDOR_WEBGL)

                    return gradeAndroidBasedOnGPU(renderer)
                }
            }
        }
        return DeviceGrades.A
    } catch {
        return DeviceGrades.A
    }
}
